export default {
  toggleCreateGroup (state) {
    state.adminpanel.colapseCreateGroup = !state.adminpanel.colapseCreateGroup
  },
  toggleEditGroup (state) {
    state.adminpanel.colapseEditGroup = !state.adminpanel.colapseEditGroup
  },
  toggleCreateYear (state) {
    state.adminpanel.colapseCreateYear = !state.adminpanel.colapseCreateYear
  },
  toggleEditYear (state) {
    state.adminpanel.colapseEditYear = !state.adminpanel.colapseEditYear
  },
  toggleCreateSubgroup (state) {
    state.adminpanel.exercises.colapseCreateSubgroup = !state.adminpanel.exercises.colapseCreateSubgroup
  },
  toggleEditSubgroup (state) {
    state.adminpanel.exercises.colapseEditSubgroup = !state.adminpanel.exercises.colapseEditSubgroup
  },
  toggleShowOrder (state) {
    state.adminpanel.exercises.colapseShowOrder = !state.adminpanel.exercises.colapseShowOrder
  },
  toggleEditDaily (state) {
    state.adminpanel.exercises.colapseEditDaily = !state.adminpanel.exercises.colapseEditDaily
  },
  toggleaily (state) {
    state.adminpanel.exercises.colapseaily = !state.adminpanel.exercises.colapseaily
  },
  changeSaveResultAdminpanel (state, newValue) {
    state.adminpanel.saveResult = newValue
  },
  changeDeleteRefreshAdminpanel (state, newValue) {
    state.adminpanel.deleteRefresh = newValue
  },
  updateGroupList (state, newValue) {
    state.groupList = newValue
  },
  updateAllGroups (state, newValue) {
    state.allGroups = newValue
  },
  updateSubgroupsBreadcrumbs (state, newValue) {
    state.subgroupsBreadcrumbs = newValue
  },
  updateAdminBreadcrumbs (state, newValue) {
    state.adminBreadcrumbs = newValue
  },
  addNewGroup (state, newValue) {
    state.groupList.push(newValue)
  },
  addNewYear (state, newValue) {
    state.selectedGroup.years.push(newValue)
  },
  addDailyChallenge (state, newValue) {
    state.adminpanel.exercises.dailyChallenges.push(newValue)
  },
  addNewSubgroup (state, newValue) {
    state.selectedGroup.subgroups.push(newValue)
  },
  deleteSubgroup (state, subgroup) {
    state.selectedGroup.subgroups = state.selectedGroup.subgroups.filter(el => el.id !== subgroup.id)
  },
  deleteSelectedYear (state, idOfYear) {
    state.selectedGroup.years = state.selectedGroup.years.filter((year) => year.id !== idOfYear)
  },
  updateSelectedGroup (state, newValue) {
    state.selectedGroup = newValue || state.groupList.find((el) => el.name !== null) || state.initialSelectedGroup
    // state.selectedYear = state.selectedGroup.years.find((el) => el.name !== null) || state.initialSelectedYear
  },
  updateSelectedGroupObj (state, newState) {
    state.selectedGroup[newState.key] = newState.value
  },
  updateYearObj (state, newState) {
    state.selectedYear[newState.key] = newState.value
  },
  updateSelectedYear (state, newYear) {
    state.selectedYear = newYear || state.selectedGroup.years.find((el) => el.name !== null) || state.initialSelectedYear
  },
  updateRegisterEmail (state, newValue) { // register
    state.register.email = newValue
  },
  resetRegisterForm (state) {
    state.register = {
      email: '',
      username: '',
      name: '',
      surname: '',
      password: '',
      password2: '',
      studentId: '',
      status: ''
    }
  },
  updateRegisterUsername (state, newValue) {
    state.register.username = newValue
  },
  updateRegisterName (state, newValue) {
    state.register.name = newValue
  },
  updateRegisterSurname (state, newValue) {
    state.register.surname = newValue
  },
  updateRegisterPassword (state, newValue) {
    state.register.password = newValue
  },
  updateRegisterPassword2 (state, newValue) {
    state.register.password2 = newValue
  },
  updateRegisterStudentId (state, newValue) {
    state.register.studentId = newValue
  },
  updateRegisterStatus (state, newValue) {
    state.register.status = newValue
  },
  // updateLoginResetForm (state, newValue) {
  //   state.showResetForm = newValue
  // },
  updateLoginIdentifier (state, newValue) { // login
    state.login.identifier = newValue
  },
  updateLoginPassword (state, newValue) {
    state.login.password = newValue
  },
  updateLoginRememberMe (state, newValue) {
    state.login.rememberMe = newValue
  },
  updateLoginStatus (state, newValue) {
    state.login.status = newValue
  },
  updateLoginSubmited (state, newValue) {
    state.login.submited = newValue
  },
  updateUserData (state, newValue) { // data about the user just like /user/me
    state.userData = newValue
  },
  updateProfilePicture (state, newValue) {
    state.userData.profilePictureUrl = newValue
  },
  updateAnnouncedDevices (state, newValue) {
    state.exam.announcedDevices = newValue
  },
  updateAnnouncedTableState (state, newState) {
    state.exam.announcedTableState[newState.key] = newState.value
  },
  updateTableStateAll (state, newState) { // exam
    state.exam.tableStateAll[newState.key] = newState.value
  },
  updateDeviceIdentifier (state, newValue) {
    state.exam.mutationDevice.identifier = newValue
  },
  updateDeviceId (state, newValue) {
    state.exam.mutationDevice.id = newValue
  },
  updateDeviceName (state, newValue) {
    state.exam.mutationDevice.name = newValue
  },
  updateDeviceGroup (state, newValue) {
    state.exam.mutationDevice.group = newValue
  },
  updateDeviceComment (state, newValue) {
    state.exam.mutationDevice.comment = newValue
  },
  updateDevicePassword (state, newValue) {
    state.exam.mutationDevice.password = newValue
  },
  updateAllDevices (state, newValue) {
    state.exam.allDevices = newValue
  },
  updateTableStateAllExercise (state, newState) { // exercise
    state.exercises.tableStateAll[newState.key] = newState.value
  },
  updateAllExercises (state, newValue) { // exercise
    state.exercises.allExercises = newValue
  },
  updateQuestionObject (state, newState) {
    state.exercises.submitExercise[newState.key] = newState.value
  },
  updateExercisesInOrder (state, newValue) {
    state.exercisesInOrder = newValue
  },
  updateExerciseForModal (state, newValue) {
    state.exerciseForModal = newValue
  },
  updateGlobalStatistics (state, newValue) {
    state.statistics.global = newValue
  },
  updateDailyChallenges (state, newValue) {
    state.adminpanel.exercises.dailyChallenges = newValue
  },
  updateSelectedDaily (state, newValue) {
    state.adminpanel.exercises.selectedDaily = newValue
  },
  updateSubgroups (state, newValue) {
    state.adminpanel.exercises.subgroups = newValue
  },
  destroySubgroupsBreadcrumbs (state) {
    state.subgroupsBreadcrumbs = []
  },
  updateSelectedExercises (state, newValue) {
    state.exercises.selectedExercises = newValue
  },
  addExercisesToSubgroup (state, newValue) {
    state.tmpAddExercises = newValue
  },
  updatePicker (state, newValue) {
    state.exam.picker = newValue
  },
  updateSelectedGroupId (state, newValue) {
    state.selectedGroupId = newValue
  },
  updateReports (state, newValue) {
    state.reports = newValue
  },
  updateExercisesForOrder (state, newValue) {
    state.exercisesForOrder = newValue
  },
  updateIncorrectTrigger (state, newValue) {
    state.exercises.incorrectTrigger = newValue
  },
  set401ToastShown (state, value) {
    state.is401ToastShown = value
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js